<template>
  <b-container fluid>
    <template v-if="navBtn">
      <b-row class="py-3">
        <b-col cols="auto">
          <b-button
            @click="$emit('back')"
          >
            ย้อนกลับ
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            variant="success"
            @click="submitHandler"
          >
            บันทึก
          </b-button>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col class="px-0">
        <b-table
          :fields="fields"
          :items="priceGroups"
        >
          <template
            slot="price"
            slot-scope="data"
          >
            <b-form-input
              v-model="data.item.price"
              type="number"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template v-if="blockBtn">
      <b-row>
        <b-col>
          <b-button
            variant="success"
            block
            @click="submitHandler"
          >
            บันทึก
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
  export default {
    name: "PriceGroup",
    props: {
      value: {
        type: Array,
        default: () => []
      },
      navBtn: {
        type: Boolean,
        default: false
      },
      blockBtn: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        fields: [
          {
            name: 'รายละเอียด',
            key: 'detail'
          },
          {
            name: 'ราคา',
            key: 'price'
          }
        ]
      }
    },
    computed: {
      priceGroups: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      async submitHandler() {

        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('submit', password)
        } else {
          return
        }

      }
    }
  }
</script>

<style scoped>

</style>